export enum STATIC_SELECT {
  COUNTRIES = 'countries',
}
